/**
 * The per-method label field in the checkout step config — what a shopper
 * reads on that payment row.
 *
 * The box shows an untouched default as its placeholder rather than as a
 * filled-in value: a solid "Card Payments" under a field the merchant has to
 * interpret is what two of them read as a cardholder name (#TAG-2724). An
 * empty box therefore means "use the default", and is stored as the default —
 * storing '' would make the deployed page fall back to the method key and
 * render "Card" (tagada-resolver.ts), and the Studio canvas "Credit Card".
 */

export function labelInputValue(stored: string, fallback: string): string {
  return stored === fallback ? '' : stored;
}

export function labelWriteBack(typed: string, fallback: string): string {
  return typed === '' ? fallback : typed;
}
